// extracted by mini-css-extract-plugin
export default {"icon_wrapper":"FavouritesButton_icon_wrapper__F25k9","count_of_favourites":"FavouritesButton_count_of_favourites__oke5Q","shimmer":"FavouritesButton_shimmer__dqgSM"};